import { Form } from 'antd';
import styled from 'styled-components';
import { CALENDAR_VIEW_TYPE } from 'features/appointment/services/constants';
import moment from 'moment';
import { DATE_FORMAT } from 'features/appointment/utils/format';
import { REPORT_PAGE_SIZE } from 'features/report/services/constants';
import SwitchCalendarType from 'components/SwitchCalendarType';
import AppointmentDatePicker from 'components/AppointmentDatePicker';
import StaffSearchInput from 'widgets/Staff/StaffSearchInput';
import { IStaffAdjustmentSaleParams } from 'features/report/services/types/api';
import useGetListSaleAdjustment from 'features/report/services/hooks/useGetListSaleAdjustment';

interface IFormValues {
  staffId?: string;
  viewType: CALENDAR_VIEW_TYPE;
  startEndDate: {
    startTime: string;
    endTime: string;
  };
  page: number;
}

const HeaderFilter = () => {
  const [form] = Form.useForm();
  const { saleAdjustmentParams, mutate } = useGetListSaleAdjustment(true);
  // const modalAdjustSale = useModalAdjustSale();
  const handleFilter = (values: any) => {
    const data = values as IFormValues;
    const params: IStaffAdjustmentSaleParams = {
      page: data.page,
      size: REPORT_PAGE_SIZE,
      startDate: data.startEndDate.startTime,
      endDate: data.startEndDate.endTime,
      staffId: data.staffId,
    };
    mutate(params);
  };

  const handlePickAllStaff = () => {
    form.setFieldsValue({ staffId: undefined });
    form.submit();
  };

  const handlePickStaff = (staff: { id: string }) => {
    form.setFieldsValue({ staffId: staff.id });
    form.submit();
  };
  
  return (
    <>
      <FilterBox
        form={form}
        onFinish={handleFilter}
        initialValues={{
          viewType: CALENDAR_VIEW_TYPE.DAY_VIEW,
          startEndDate: { startTime: moment().format(DATE_FORMAT), endTime: moment().format(DATE_FORMAT) },
          page: 1,
        }}
      >
        {/* <Form.Item name={'staffId'} noStyle>
          <StaffSearchInput onPickAll={handlePickAllStaff} onPickStaff={handlePickStaff} sizeAvatar={32}/>
        </Form.Item> */}
        <Form.Item name={'viewType'} noStyle>
          <SwitchCalendarType
            submitOnChange
            onSubmit={(params) => {
              form.setFieldsValue({ startEndDate: params });
            }}
          />
        </Form.Item>
        <Form.Item noStyle shouldUpdate dependencies={['viewType']}>
          {() => {
            const viewType = form.getFieldValue('viewType');
            return (
              <Form.Item name={'startEndDate'} noStyle>
                <AppointmentDatePicker viewType={viewType} onChange={() => form.submit()} />
              </Form.Item>
            );
          }}
        </Form.Item>
        <Form.Item name={'page'} noStyle />
      </FilterBox>
    </>
  );
};

export default HeaderFilter;

// const FixedTopSection = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 24px;
//   flex-shrink: 0;
//   background: #fff;
//   z-index: 10;
// `;

const FilterBox = styled(Form)`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  .style-antd-select {
    min-width: 150px;
  }

  .ant-input-affix-wrapper {
    padding: 0 12px;
    height: 56px!important;
  }

  .button {
    height: 56px!important;
  }
`;